import { render } from "./EmailInbox.vue?vue&type=template&id=3bc00e75&scoped=true"
import script from "./EmailInbox.vue?vue&type=script&lang=js"
export * from "./EmailInbox.vue?vue&type=script&lang=js"

import "./EmailInbox.vue?vue&type=style&index=0&id=3bc00e75&scoped=true&lang=css"

import exportComponent from "C:\\SeaFarer\\SeaFarer\\AMDTransportation_FE\\amd_transportation_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc00e75"]])

export default __exports__